import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { EmployeeService } from '../../employee/services/employee.service';


@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent {

  dynamicForm!: FormGroup;
  @Input() formData: any;
  @Output() submitData = new EventEmitter<any>();
  data: any = null
  company: any;
  companyList: any;
  constructor(
    private fb: FormBuilder,
    private employeeService: EmployeeService
  ) { }

  ngOnInit() {
    if (this.formData)
      this.createForm();
    if (Object.keys(this.formData).includes('companyId')){
      this.initializeEmployee();
    }
  }

  createForm() {
    const formControls: { [key: string]: FormControl } = {};

    Object.entries(this.formData).forEach(([key, value]) => {
      formControls[key] = new FormControl(value['value']);
    });

    this.dynamicForm = this.fb.group(formControls);
  }

  initializeEmployee() {
    this.company = {
      companyName: "Select Company",
      address: "",
      city: "",
      state: "",
      country: "",
      zipCode: null,
    }

    this.employeeService.getCompanyListByType().subscribe(res => {
      if (res?.data?.getCompanyByType && res?.data?.getCompanyByType.length > 0) {
        res.data.getCompanyByType.forEach(data => {
          if (!this.companyList) this.companyList = []
          this.companyList.push(data.company)
        });
      }
    })
  }

  onOptionSelect(event, data) {
    this.data = event.data
    this.dynamicForm.patchValue({
      [data.type]: event.data.id
    })
  }

  onSubmit() {
    this.submitData.emit({ formData: this.dynamicForm.value, data: this.data })
  }
}
